export const Spinner=()=>{
    return (
        <div className="loading-circle"></div>
    )
}